import { api } from './client';

export interface ChannelLink {
  linked: boolean;
  chat_id: string | null;
  invite_url: string | null;
  reason: string | null;
}

export interface ChatLinks {
  tg: ChannelLink;
  max: ChannelLink;
}

export const chatLinksApi = {
  get: (orgId: string) =>
    api.get<ChatLinks>(`/api/v1/organizations/${orgId}/chat-links`).then(r => r.data),
};
